export default class EmergencyCardModel {
  constructor({
    emergency: {
      button_label: buttonLabel,
      link,
      title,
    },
  } = { emergency: {} }) {
    this.buttonLabel = buttonLabel;
    this.link = link;
    this.title = title;
  }

  getButtonLabel() {
    return this.buttonLabel;
  }

  getLink() {
    return this.link;
  }

  getTitle() {
    return this.title;
  }
}
